export default __webpack_public_path__ + "static/media/Lock.e6e9c8ff.svg";